import React from "react";
import Button from "../../components/Button/Button";
import styles from "./LandingPage.module.css";
import logo from "../../assets/house-icon-logo.png";
import { Link, useNavigate } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();

  function handleClickLogin() {
    navigate("/login");
  }

  return (
    <div className={styles.component}>
      {/* Header */}
      <div className={styles.landingHeader}>
        <div className={styles.logoName}>
          <img src={logo} width={60} height={60} alt="HomeMate logo" />
          <h1>HomeMate</h1>
        </div>
        <h2>
          Find your place. <span className={styles.mobile_break}></span> Find your people.
        </h2>
      </div>

      {/* Main Section */}
      <div className={styles.bottom}>
        <div className={styles.img_overlay}></div>

        <div className={styles.text}>
            <div className={styles.textBlock}>
          <p>All your subleasing needs. All in one app.</p>
          <p>📸 Post. 🤝 Match. 🏠 Move in.</p>
          <p>
            Detail-rich listings, roommate matching, effortless messaging — subleasing without the stress.
          </p>

          <div className={styles.links}>
            {/* ✅ Login Button */}
            <Button onClick={handleClickLogin}>Login</Button>

            {/* ✅ “Already have an account?” text */}
            <p className={styles.signupText}>
              Don't have an account?{" "}
              <Link to="/register" className={styles.signupLink}>
                Sign Up
              </Link>
            </p>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
